export default "<p>manage-digicod works!</p>\n"